// extracted by mini-css-extract-plugin
export default {"container":"wJxQxG","iconWrapper":"JGMoeQ"};